// @ts-nocheck
import { Grid } from '@mantine/core'
import React, { ReactElement } from 'react'
import { Col, Form as BtForm, FormControl } from 'react-bootstrap'

import CountryPicker from '../../../../../../../1stlog-ui/src/components/CountryPicker'
import CurrencyInput from '../../../../../../../1stlog-ui/src/components/CurrencyInput'
import DecimalInput from '../../../../../../../1stlog-ui/src/components/DecimalInput'
import Field, {
  composeValidators,
  mustBeNumber,
  mustBePositive,
  required,
} from '../../../../../../../1stlog-ui/src/components/Field'
import Input from '../../../../../../../1stlog-ui/src/components/Input'
import NumberInput from '../../../../../../../1stlog-ui/src/components/NumberInput'
import TariffWizard from '../../../../../TariffWizard'
import CustomsSearchAutocomplete from './CustomsSearchAutocomplete'
import Preference from './Preference'

const CustomsItemForm = (props): ReactElement => {
  const {
    exportCountry,
    importCountry,
    onApplyValues,
    disableSearchAutocomplete,
    simpleZtn,
  } = props

  const isChImportExport = importCountry === 'CH' || exportCountry === 'CH'

  return (
    <>
      <Grid columns={32} className="mt-1">
        <Grid.Col span={3}>
          <Field
            // size="sm"
            name="count"
            validate={required}
            label={i18n.t('count', 'Anzahl')}
            required
          >
            <NumberInput
              hideButtons
              block
              short
              noMargin
              min={1}
              max={99999}
              mustBePositive
            />
          </Field>
        </Grid.Col>
        <Grid.Col span={7}>
          <Field
            // size="sm"
            name="articleNumber"
            label={i18n.t('article_nunber_or_reference', 'Artikelnr./Referenz')}
          >
            <CustomsSearchAutocomplete
              onApplyValues={onApplyValues}
              disableAutocomplete={disableSearchAutocomplete}
            />
          </Field>
        </Grid.Col>

        <Grid.Col span={5}>
          <CountryPicker
            name="originCountry"
            label={i18n.t('label_country_origin', 'Ursprungsland')}
            validation={required}
            // small
            autoComplete="none"
            required
            direct
          />
        </Grid.Col>
        <Grid.Col span={6}>
          <CurrencyInput
            name="value"
            label={i18n.t('value_of_goods_per_unit', 'Warenwert pro Einheit')}
            validate={composeValidators(required, mustBePositive)}
            required
            small
          />
        </Grid.Col>

        <Grid.Col span={5}>
          <Field
            // size="sm"
            key={String(isChImportExport)}
            name="netWeight"
            validate={composeValidators(
              isChImportExport ? required : undefined,
              isChImportExport ? mustBeNumber : undefined,
              mustBePositive,
              // mustBeSmallerOrEqualGrossWeigth
            )}
            label={i18n.t('net_weight_kg', 'Nettogewicht (kg)')}
            required={isChImportExport}
          >
            <DecimalInput
              placeholder={i18n.t('without_packaging', 'ohne Verpackung')}
            />
          </Field>
        </Grid.Col>
        <Grid.Col span={5}>
          <Preference />
        </Grid.Col>
      </Grid>
      <BtForm.Row>
        <Col md="12" xs="12">
          <Field
            name="description"
            validate={required}
            label={i18n.t('label_goods_name', 'Warenbezeichnung')}
            // size="sm"
            required
          >
            <FormControl />
          </Field>
        </Col>
      </BtForm.Row>
      {simpleZtn ? (
        <BtForm.Row>
          <Col md="12">
            <Field
              name="tariffNumber"
              label={i18n.t('label_customs_nmb', 'Zolltarifnummer')}
            >
              <Input />
            </Field>
          </Col>
        </BtForm.Row>
      ) : (
        <TariffWizard
          onlyExport
          exportCountry={exportCountry}
          importCountry={importCountry}
        />
      )}
    </>
  )
}

export default CustomsItemForm
